import { render, staticRenderFns } from "./TherapysList.vue?vue&type=template&id=7436f649&scoped=true&"
import script from "./TherapysList.vue?vue&type=script&lang=js&"
export * from "./TherapysList.vue?vue&type=script&lang=js&"
import style0 from "./TherapysList.vue?vue&type=style&index=0&id=7436f649&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7436f649",
  null
  
)

export default component.exports